import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import getters from './getters'
import login from './modules/login'
import params from './modules/params'
import corporation from './modules/corporation'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    login,
    params,
    corporation
  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js